export const GENERIC_ERROR = "Something went wrong. Please try again.";
